'use strict';

var React = require('react');

var PropTypes = require('prop-types');

var internals = require('@sanity/block-content-to-hyperscript/internals');

var _require = require('./targets/dom'),
    serializers = _require.serializers,
    serializeSpan = _require.serializeSpan,
    renderProps = _require.renderProps;

var getImageUrl = internals.getImageUrl,
    blocksToNodes = internals.blocksToNodes,
    mergeSerializers = internals.mergeSerializers;
var renderNode = React.createElement;

var SanityBlockContent = function SanityBlockContent(props) {
  var customSerializers = mergeSerializers(SanityBlockContent.defaultSerializers, props.serializers);
  var blockProps = Object.assign({}, renderProps, props, {
    serializers: customSerializers,
    blocks: props.blocks || []
  });
  return blocksToNodes(renderNode, blockProps, serializers, serializeSpan);
}; // Expose default serializers to the user


SanityBlockContent.defaultSerializers = serializers; // Expose logic for building image URLs from an image reference/node

SanityBlockContent.getImageUrl = getImageUrl;
SanityBlockContent.propTypes = {
  className: PropTypes.string,
  renderContainerOnSingleChild: PropTypes.bool,
  ignoreUnknownTypes: PropTypes.bool,
  // When rendering images, we need project id and dataset, unless images are materialized
  projectId: PropTypes.string,
  dataset: PropTypes.string,
  imageOptions: PropTypes.object,
  serializers: PropTypes.shape({
    // Common overrides
    types: PropTypes.object,
    marks: PropTypes.object,
    // Less common overrides
    list: PropTypes.func,
    listItem: PropTypes.func,
    // Low-level serializers
    block: PropTypes.func,
    span: PropTypes.func
  }),
  blocks: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
    _type: PropTypes.string.isRequired
  })), PropTypes.shape({
    _type: PropTypes.string.isRequired
  })]).isRequired
};
SanityBlockContent.defaultProps = {
  ignoreUnknownTypes: true,
  renderContainerOnSingleChild: false,
  serializers: {},
  imageOptions: {}
};
module.exports = SanityBlockContent;